document.addEventListener("DOMContentLoaded", function () {
  const dropdown = document.querySelector(".language-dropdown");
  const opener = document.querySelector(".language-toggle");

  if (opener && dropdown) {
    opener.addEventListener("click", function (event) {
      event.stopPropagation();
      dropdown.classList.toggle("open");
    });

    document.addEventListener("click", function (event) {
      if (!dropdown.contains(event.target) && !opener.contains(event.target)) {
        dropdown.classList.remove("open");
      }
    });
  }
});

console.log('=== SCRIPT DE IDIOMA INICIADO ===');

(function() {
  const path = window.location.pathname;
  
  // =========================
  //    MAPAS
  // =========================
  const redirectMap = {
    "/es/products/customize-your-hat": "/es/products/personalice-su-sombrero-usd",
    "/products/personalice-su-sombrero-usd": "/es/products/personalice-su-sombrero-usd",
    "/es/products/customize-your-hat-cop": "/es/products/personalice-su-sombrero",
    "/products/personalice-su-sombrero": "/es/products/personalice-su-sombrero"
  };

  const localeEquivalents = {
    "/products/customize-your-hat": "/es/products/personalice-su-sombrero-usd",
    "/es/products/personalice-su-sombrero-usd": "/products/customize-your-hat",
    "/products/customize-your-hat-cop": "/es/products/personalice-su-sombrero",
    "/es/products/personalice-su-sombrero": "/products/customize-your-hat-cop"
  };
  
  // =========================
  //   REDIRECCIÓN DIRECTA
  // =========================
  if (redirectMap[path] && redirectMap[path] !== path) {
    console.log('Redirigiendo de', path, 'a', redirectMap[path]);
    window.location.replace(redirectMap[path]); 
    return;
  }
  
  // =========================
  //   FUNCIÓN INTERCEPTOR
  // =========================
  function interceptLanguageChange(form, isMobile) {
    const formType = isMobile ? 'MÓVIL' : 'HEADER';
    console.log(`=== Configurando interceptor ${formType} ===`);
    
    // Interceptar submit
    form.addEventListener('submit', function(e) {
      console.log(`=== SUBMIT ${formType} DETECTADO ===`);
      
      const localeInput = this.querySelector('input[name="locale_code"]');
      const clickedButton = e.submitter;
      
      let selectedLocale = null;
      
      if (isMobile && clickedButton) {
        selectedLocale = clickedButton.value;
      } else if (localeInput) {
        selectedLocale = localeInput.value;
      }
      
      console.log('Locale seleccionado:', selectedLocale);
      
      const currentPath = window.location.pathname;
      const currentLocale = currentPath.startsWith('/es/') ? 'es' : 'en';
      
      console.log('Locale actual:', currentLocale);
      console.log('Path actual:', currentPath);
      
      if (selectedLocale && selectedLocale !== currentLocale && localeEquivalents[currentPath]) {
        console.log('=== PREVINIENDO Y REDIRIGIENDO ===');
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const targetPath = localeEquivalents[currentPath];
        console.log('Target:', targetPath);
        
        window.location.href = targetPath;
        return false;
      }
    }, true);
    
    // Para el header: también interceptar clicks en botones
    if (!isMobile) {
      const buttons = form.querySelectorAll('button[data-localization-item], button[data-value]');
      console.log('Botones header encontrados:', buttons.length);
      
      buttons.forEach((button, index) => {
        button.addEventListener('click', function(e) {
          console.log(`=== CLICK BOTÓN HEADER ${index} ===`);
          
          const selectedLocale = this.getAttribute('data-value');
          const currentPath = window.location.pathname;
          const currentLocale = currentPath.startsWith('/es/') ? 'es' : 'en';
          
          console.log('Click - Locale seleccionado:', selectedLocale);
          console.log('Click - Locale actual:', currentLocale);
          
          if (selectedLocale && selectedLocale !== currentLocale && localeEquivalents[currentPath]) {
            console.log('=== CLICK: PREVINIENDO Y REDIRIGIENDO ===');
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            const targetPath = localeEquivalents[currentPath];
            console.log('Click - Target:', targetPath);
            
            // Actualizar el input antes de redirigir (por si acaso)
            const localeInput = form.querySelector('input[name="locale_code"]');
            if (localeInput) {
              localeInput.value = selectedLocale;
            }
            
            window.location.href = targetPath;
            return false;
          }
        }, true);
      });
    }
  }
  
  // =========================
  //   CONFIGURAR SELECTORES
  // =========================
  function setupSelectors() {
    // Móvil (ya existe)
    const mobileForm = document.querySelector('#mobile-language-switcher form');
    if (mobileForm && !mobileForm.dataset.intercepted) {
      console.log('✅ Selector MÓVIL encontrado y configurado');
      mobileForm.dataset.intercepted = 'true';
      interceptLanguageChange(mobileForm, true);
    }
    
    // Header (puede no existir aún)
    const headerForm = document.getElementById('HeaderDrawerLanguageForm');
    if (headerForm && !headerForm.dataset.intercepted) {
      console.log('✅ Selector HEADER encontrado y configurado');
      headerForm.dataset.intercepted = 'true';
      interceptLanguageChange(headerForm, false);
    }
  }
  
  // =========================
  //   MUTATION OBSERVER
  // =========================
  const observer = new MutationObserver(function(mutations) {
    setupSelectors();
  });
  
  // Observar cambios en el DOM
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // =========================
  //   EJECUCIÓN INICIAL
  // =========================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupSelectors);
  } else {
    setupSelectors();
  }
  
  // Reintentos adicionales
  setTimeout(setupSelectors, 500);
  setTimeout(setupSelectors, 1000);
  setTimeout(setupSelectors, 2000);
  setTimeout(setupSelectors, 3000);
  
  console.log('=== SCRIPT CONFIGURADO ===');
})();
